export default {"src":"/_next/static/media/formula-1.3796b261.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};